import { Component, ChangeDetectionStrategy, Input } from '@angular/core';
import { Observable } from 'rxjs';

import {
  TagMemberSize, TagMemberStyle, TagMemberType
} from '@design-system/components/molecules/tag-member/entities/tag-member.types';
import {
  getPaymentDiscountStrikethroughValue, getPaymentPercentageCalculated,
  getStrikethroughDiscount
} from '@shared/payment-detail/mappers/discount-calculated.mapper';
import { PriceDetailService } from '@shared/payment-detail/services/payment-detail.service';
import { SearchBy } from '@shared/base-search-bar/entities/search.entities';

@Component({
  selector: 'app-payment-rate-discount',
  templateUrl: './payment-rate-discount.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class PaymentRateDiscountComponent {

  @Input() product: SearchBy;
  @Input() currencyCode: string;
  @Input() calculatedPercentageBytaxes = false;
  @Input() htmlFormatByCurrency = false;
  @Input() displayCurrencyCode = false;
  @Input() amount = 0;
  @Input() discountAmount = 0;
  @Input() fees = 0;
  @Input() surcharges = 0;
  @Input() strikethrough = 0;
  @Input() taxes = 0;
  @Input() total = 0;
  @Input() totalDiscount = 0;
  @Input() totalDiscountInStrikethrough = 0;

  public readonly tagMemberStyle = TagMemberStyle.Strikethrough;
  public readonly tagMemberSize = TagMemberSize.SM;

  constructor(
    private readonly service: PriceDetailService,
  ) { }

  get tagMemberType$(): Observable<TagMemberType> {
    return this.service.getTagMemberType$(true);
  }

  get discountPercentageValueProp(): number {
    return getPaymentPercentageCalculated(
      this.calculatedPercentageBytaxes, this.strikethrough, this.total, this.discountAmount,
      this.strikethroughDiscount, this.amount, this.taxes
    );
  }

  get strikethroughValueProp(): number {
    return getPaymentDiscountStrikethroughValue(
      this.strikethrough, this.total, this.discountAmount, this.strikethroughDiscount,
      this.amount, this.taxes, this.fees, this.surcharges
    );
  }

  private get strikethroughDiscount(): number {
    return getStrikethroughDiscount(this.totalDiscountInStrikethrough, this.totalDiscount);
  }
}
